import { deleteCategory, getCategory, postCategory, putCategory } from "src/shared/services/servicesv2";

export const categoryService = {
  fetch: async (showDeleted: boolean, page: number, pageSize: number, searchTerm: string = "", sortField?: string, order?: string) => {
    const response = await getCategory(showDeleted, page + 1, pageSize, searchTerm, sortField, order);
    return response.data;
  },

  create: async (categoryData: { categoryName: string; type: string }) => {
    const response = await postCategory(categoryData);
    return response.data;
  },

  update: async (id: string | number, categoryData: { categoryName: string; type?: string }) => {
    const response = await putCategory(id, categoryData);
    return response.data;
  },

  delete: async (id: string | { $oid: string }) => {
    const idString = typeof id === "string" ? id : id.$oid;
    const response = await deleteCategory([idString]);
    return response.data;
  },
};
